const stats = [
  { num: '25+', label: 'Anni di attività' },
  { num: '500+', label: 'Professionisti serviti' },
  { num: '100%', label: 'Made in Italy' },
  { num: '48h', label: 'Produzione su misura' },
];

const regions = ['Lombardia', 'Veneto', 'Emilia Romagna'];
const allCities = [
  'Milano', 'Brescia', 'Bergamo', 'Verona', 'Padova', 'Bologna',
  'Modena', 'Parma', 'Venezia', 'Vicenza', 'Ferrara', 'Rimini',
];

export default function SocialProofSection() {
  return (
    <section
      id="chisinamo"
      aria-label="Chi siamo – Punto Cassonetti, 25 anni al servizio dei professionisti del Nord Italia"
      className="bg-white py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">

        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-[#7FCDCD] text-xs font-semibold uppercase tracking-widest mb-4">
            — La nostra storia
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#000000] mb-5 tracking-tight leading-tight"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Un partner concreto<br />per i professionisti<br />del Nord Italia
          </h2>
          <p className="text-[#A5A5A5] max-w-xl mx-auto text-sm leading-relaxed">
            Produciamo cassonetti PVC e controtelai termici su misura per serramentisti, montatori e imprese edili.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-16 md:mb-20">
          {stats.map((s) => (
            <div key={s.label} className="text-center py-8 md:py-10 bg-[#F6F6F6] rounded-xl border border-[#A5A5A5]/10">
              <div
                className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#7FCDCD] mb-2"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                {s.num}
              </div>
              <div className="text-[#A5A5A5] text-xs font-medium uppercase tracking-widest">{s.label}</div>
            </div>
          ))}
        </div>



        {/* Video in azione */}
        <div className="mb-16 md:mb-20">
          {/* Label + hint audio */}
          <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
            <div>
              <span className="text-[#7FCDCD] text-xs font-semibold uppercase tracking-widest block mb-1"
                style={{ fontFamily: "'DM Sans', sans-serif" }}>
                — Il prodotto in azione
              </span>
              <h3
                className="text-xl md:text-2xl font-extrabold text-[#000000] leading-tight tracking-tight"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                Guarda come lavoriamo
              </h3>
            </div>
            <div className="flex items-center gap-1.5 bg-[#F6F6F6] border border-[#E5E5E5] rounded-full px-3 py-1.5">
              <i className="ri-volume-mute-line text-[#7FCDCD] text-xs" />
              <span className="text-[#A5A5A5] text-xs whitespace-nowrap" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Silenzioso — attiva l&apos;audio con i controlli
              </span>
            </div>
          </div>

          {/* Video container */}
          <div className="relative rounded-2xl overflow-hidden bg-[#111111] w-full">
            <video
              src="https://www.puntocassonetti.it/wp-content/uploads/2021/07/WhatsApp-Video-2021-06-16-at-12.48.40.mp4"
              autoPlay
              muted
              loop
              playsInline
              controls
              className="w-full block"
              style={{ maxHeight: '520px', objectFit: 'contain', background: '#111111' }}
              aria-label="Video produzione cassonetti PVC su misura – Punto Cassonetti"
            />
          </div>
        </div>

        {/* Story */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16 md:mb-20">
          <div>
            <h3
              className="text-3xl lg:text-4xl font-extrabold text-[#000000] mb-6 leading-tight tracking-tight"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              25 anni al servizio<br />dei professionisti dell'edilizia<br />
              <span className="text-[#7FCDCD]">in tutto il Nord Italia</span>
            </h3>
            <p className="text-[#A5A5A5] leading-relaxed mb-5 text-sm">
              Siamo produttori di cassonetti in PVC e controtelai termici certificati Usb=1 W/m²K. Il nostro sistema brevettato Termiko® si adatta a qualsiasi foro finestra senza sopralluogo.
            </p>
            <p className="text-[#A5A5A5] leading-relaxed mb-10 text-sm">
              Serviamo serramentisti, montatori e imprese edili in Lombardia, Veneto ed Emilia Romagna con produzione su misura in 48 ore lavorative.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#form"
                className="flex items-center justify-center gap-2 bg-[#7FCDCD] hover:bg-[#6bbaba] text-white font-semibold px-6 py-3.5 rounded-md transition-colors text-sm whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                <i className="ri-file-list-3-line"></i>
                Richiedi preventivo
              </a>
              <a
                href="tel:+390519981801"
                className="flex items-center justify-center gap-2 border border-[#000000] text-[#000000] hover:bg-[#000000] hover:text-white font-semibold px-6 py-3.5 rounded-md transition-all text-sm whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                <i className="ri-phone-line"></i>
                051 9981801
              </a>
            </div>
          </div>

          {/* Reviews */}
          <div className="space-y-4">
            {[
              {
                name: 'Davide Colombo',
                role: 'Serramentista · Brescia',
                text: 'Collaboro con Punto Cassonetti per la fornitura di cassonetti PVC in Lombardia. Tempi rispettati, qualità costante.',
              },
              {
                name: 'Roberto Tessaro',
                role: 'Impresa Edile · Padova',
                text: 'Il Termiko® ha rivoluzionato i nostri cantieri in Veneto. Zero sopralluoghi, installazione immediata.',
              },
              {
                name: 'Gianluca Ferrari',
                role: 'Montatore · Parma',
                text: 'Controtelai termici di ottima fattura. La produzione in 48 ore ci permette di pianificare i lavori con precisione.',
              },
            ].map((r) => (
              <article
                key={r.name}
                className="bg-[#F6F6F6] rounded-xl p-5 border border-[#A5A5A5]/10"
                itemScope
                itemType="https://schema.org/Review"
              >
                <div className="flex items-center gap-1 mb-3" itemProp="reviewRating" itemScope itemType="https://schema.org/Rating">
                  <meta itemProp="ratingValue" content="5" />
                  <meta itemProp="bestRating" content="5" />
                  {[1,2,3,4,5].map((s) => (
                    <i key={s} className="ri-star-fill text-yellow-400 text-xs"></i>
                  ))}
                </div>
                <p
                  className="text-[#A5A5A5] text-xs leading-relaxed mb-4"
                  itemProp="reviewBody"
                >
                  &quot;{r.text}&quot;
                </p>
                <div itemProp="author" itemScope itemType="https://schema.org/Person">
                  <div className="font-bold text-[#000000] text-xs" itemProp="name">{r.name}</div>
                  <div className="text-[#A5A5A5] text-xs">{r.role}</div>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* Area geografica */}
        <div id="aree" className="relative rounded-2xl p-8 md:p-12 overflow-hidden">
          {/* Background image + mask */}
          <img
            src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/f45bcdcb20ca7c3ebe187a48738ed4cd.jpeg"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/70 rounded-2xl" />

          {/* Content */}
          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <h3
                className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white mb-4 leading-tight tracking-tight"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                Cassonetti PVC su misura<br />
                <span className="text-[#7FCDCD]">Lombardia · Veneto · Emilia Romagna</span>
              </h3>
              <p className="text-white/40 text-sm leading-relaxed mb-5">
                Serviamo professionisti in tutto il Nord Italia con produzione su misura, preventivo personalizzato e consegna rapida.
              </p>
              <div className="flex flex-wrap gap-2 mb-5">
                {regions.map((r) => (
                  <span key={r} className="bg-[#7FCDCD]/15 border border-[#7FCDCD]/25 text-[#7FCDCD] text-xs font-semibold px-3 py-1.5 rounded-full">
                    {r}
                  </span>
                ))}
              </div>
              <a
                href="https://www.google.com/maps/place/Via+dei+Lapidari,+15,+40129+Bologna"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 text-[#7FCDCD] text-sm font-semibold hover:underline cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-pin-2-line"></i>
                Via dei Lapidari, 15 – 40129 Bologna
              </a>
            </div>
            <div>
              <p className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-5">Principali città servite</p>
              <div className="grid grid-cols-3 gap-x-3 gap-y-3">
                {allCities.map((a) => (
                  <div key={a} className="flex items-center gap-1.5 text-white/50 text-xs hover:text-white/80 transition-colors">
                    <i className="ri-map-pin-fill text-[#7FCDCD] text-xs flex-shrink-0"></i>
                    <span>{a}</span>
                  </div>
                ))}
              </div>
              <div className="mt-5 border border-white/10 rounded-lg px-4 py-3 inline-flex items-center gap-2">
                <i className="ri-map-2-line text-[#7FCDCD] text-sm"></i>
                <span className="text-white/50 text-xs">+ tutto il Nord Italia</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
